import React, { useEffect, useRef } from 'react'

import {ReactComponent as IconArrowDown} from '../../../../assets/icons/ic-arrow-down-gray.svg'
import {ReactComponent as IconArrowUp} from '../../../../assets/icons/ic-arrow-up-gray.svg'
import {ReactComponent as IconCheckBlue} from '../../../../assets/icons/ic-check-blue.svg'

const Dropdown = ({ type, isShow, unit, value, valueArr, customWidth, handleClick, handleValueClick }) => {
    const openRef = useRef(null)
    const dropdownRef = useRef(null)

    const handleClickOutside = (event) => {
        if (openRef.current && openRef.current.contains(event.target)) {
            return
        }
        if(dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            handleClick(false)
        }
    }

    useEffect(() => {
        window.addEventListener('mousedown', handleClickOutside);
    }, [])

    return (
        <div ref={openRef} className="relative flex items-center mr-2 text-black cursor-pointer" onClick={() => { handleClick() }} style={{ padding: '7px 8px', width: customWidth || 212, height: 32, borderRadius: 6, border: '1px solid #CECECE', background: 'white'}}>
            <span className="" style={{ fontWeight: 300 }}>{ value.label }</span>
            <div className="ml-auto flex items-center">
                {
                    unit && <div className="mr-2 opacity-50" style={{ fontWeight: 300 }}>{ unit }</div>
                }
                {
                    isShow ? <IconArrowUp /> : <IconArrowDown />
                }
            </div>
            {
                isShow &&
                <div ref={dropdownRef} className="absolute bg-white rounded-[6px] scrollbar scrollbar--gray" style={{ maxHeight: 200, width: customWidth || 212, top: 32, left: 0, zIndex: 9999, padding: '8px 0', border: '1px solid #5E5E5E', boxShadow: '0px 12px 12px 0px #00000099' }}>
                    {
                        valueArr.map((item, idx) => {
                            return (
                                <div 
                                    onClick={() => { handleValueClick(item) }}
                                    className="flex items-center px-2 room-list-item"
                                    key={`dropdown-list-item-${type}-${idx}`}
                                    style={{ height: 32, color: item.label === value.label ? '#3182F7' : '', fontWeight: 300 }}>
                                    { item.label }
                                    {
                                        item.label === value.label &&
                                        <IconCheckBlue className="ml-auto"/>
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            }
        </div>
    )
}

export default Dropdown